export const FETCH_SITE_GROUP_REQUEST = '@siteGroup/FETCH_SITE_GROUP_REQUEST';
export const FETCH_SITE_GROUP_SUCCESS = '@siteGroup/FETCH_SITE_GROUP_SUCCESS';
export const FETCH_SITE_GROUP_FAILURE = '@siteGroup/FETCH_SITE_GROUP_FAILURE';
